import React from 'react';

const LogoMenu = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.01" height="13.611" viewBox="0 0 19.01 13.611">
        <g id="Componente_32_17" data-name="Componente 32 – 17" transform="translate(0.25 0.25)">
            <g id="Grupo_2219" data-name="Grupo 2219" transform="translate(0 -74.667)" opacity="0.77">
                <path id="Trazado_897" data-name="Trazado 897" d="M17.353,224H1.157a1.157,1.157,0,1,0,0,2.314h16.2a1.157,1.157,0,1,0,0-2.314Z" transform="translate(0 -143.934)" fill="#4bc4ec" stroke="#00161d" strokeWidth="0.5"/>
                <path id="Trazado_898" data-name="Trazado 898" d="M1.157,76.981h16.2a1.157,1.157,0,0,0,0-2.314H1.157a1.157,1.157,0,0,0,0,2.314Z" fill="#4bc4ec" stroke="#00161d" strokeWidth="0.5"/>
                <path id="Trazado_899" data-name="Trazado 899" d="M17.353,373.333H1.157a1.157,1.157,0,1,0,0,2.314h16.2a1.157,1.157,0,1,0,0-2.314Z" transform="translate(0 -287.869)" fill="#4bc4ec" stroke="#00161d" strokeWidth="0.5"/>
            </g>
        </g>
    </svg>
);

export default LogoMenu;
